<section id="content" class="schdule-course-list" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>Scheduled courses</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.SCHEDULEDCOURSES">Scheduled courses</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation"  [ngClass]="selectedTab === 'list' ? 'active' : 'none'"><a href="#listTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">List</a></li>
                  <li role="presentation" [ngClass]="selectedTab === 'maintenanceTab' ? 'active' : 'none'"><a href="#maintenanceTab" aria-controls="maintenanceTab" role="tab"
                      data-toggle="tab">Planning</a></li>
                </ul>

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-2" style="width: 20%;">
                        <div class="social-icons">

                          <a (click)="addEditAcademyModal('','add')" class="plus-add" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a> 

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>


                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                        
                  
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="get_sechu_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>No.</th>
                            <th>{{ lang.courseCode }}</th>
                            <th>{{ lang.catalogCode }}</th>
                            <th>{{ lang.courseTitle }}</th>
                            <th>{{ lang.description }}</th>
                            <th>Actuator Body</th>
                            <th>{{ lang.courseCategory }}</th>
                            <th>{{ lang.durationHours }}</th>
                            <th>{{ lang.startDate }}</th>
                            <th>{{ lang.endDate }}</th>
                            <th>{{ lang.teacher }}</th>
                            <th>{{ lang.customer }}</th>
                            <th>No. of {{ lang.noofattendies }}</th>
                            <th>{{ lang.status }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let record of get_sechu_data let i = index" id="{{record.scheduled_courseId }}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td><a  [routerLink]="['/'+AppFrontRoutes.SCHEDULED_COURSE_VIEW+'/'+record.scheduled_courseId]">{{ record.course_code }}</a></td>
                            <td>{{ record.cat_code }}</td>
                            <td>{{ record.description }}</td>
                            <td>{{ record.discription }}</td>
                            <td>{{ record.act_body }}</td>
                            <td>{{ record.sc_course_catgy }}</td>
                            <td>{{ record.m_drtn }}</td>
                            <td>{{ record.sdate }}</td>
                            <td>{{ record.edate }}</td>
                            <td>{{ record.qualified_teacheName }}</td>
                            <td>{{ record.customer }}</td>
                            <td>{{ record.employees_count }}</td>
                            <td>{{ record.sc_sched_status }}</td>
                            <td> <div class="btn-group dropup">
                            
                              <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                                aria-expanded="false"><i class="fa fa-tasks"></i></button>
  
                              <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.scheduled_courseId)"><i class="fa fa-trash"></i>Erase</a></li>
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action" (click)="addEditAcademyModal(record,'edit')"><i class="fa fa-edit"></i>Modify</a></li>
                                <li>
                                  <a  [routerLink]="['/'+AppFrontRoutes.SCHEDULED_COURSE_VIEW+'/'+record.scheduled_courseId]"><i class="glyphicon glyphicon-eye-open"></i>View</a></li>
  
                              </ul>
                            </div></td>

                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>


                  <div role="tabpanel" class="tab-pane" id="maintenanceTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a [routerLink]="['/'+AppFrontRoutes.CREATE_SCHEDULE_COURSE]" class="plus-add" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <!-- <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>-->

                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a> 

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                  
                    </div>

                    
                  </div>


                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> Select All</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left uppercase">{{ lang?.importCustomer }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a [routerLink]="">{{ lang?.clickhere }}</a> {{ lang?.todownloadcsvformat }} </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS
        </h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> Select All
            </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns
            </h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<script type="text/javascript">

</script>